import axios from '../../plugins/axios'
import router from '../../router'

export default {
  namespaced: true,
  state: {
    authenticated: localStorage.getItem('token') ? true : false,
    token: localStorage.getItem('token'),
    userData: JSON.parse(localStorage.getItem('userData'))
  },
  getters: {
    userCompany: (state) => state.userData ? state.userData.employee.Company : {},
    userDepartment: (state) => {
      if (state.userData) {
        const employeeAssignments = state.userData.employee.EmployeeAssignments

        if (employeeAssignments) {
          return employeeAssignments.length ? employeeAssignments[0].Department : {}
        } else {
          return {}
        }
      } else {
        return {}
      }
    },
    profile (state) {
      const base64Url = state.token.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))

      return JSON.parse(jsonPayload)
    }
  },
  mutations: {
    successLogin(state, userData) {
      state.authenticated = true
      state.userData = userData

      localStorage.setItem('token', userData.token)
      localStorage.setItem('userData', JSON.stringify(userData))

      axios.defaults.headers.common['Authorization'] = `Bearer ${userData.token}`

      router.push('/')
    },

    logout(state) {
      localStorage.removeItem('token')
      localStorage.removeItem('userData')

      state.authenticated = false
      state.userData = {}

      router.push('/login')
    }
  }
}